import http from 'services/http-service';

const AuthService = {
    GetUserByToken() {
        let result = http.get('/me');
        return result;
    },

    GetLoggedInUserProfile() {
        let result = http.get('/accounts/loggedIn');
        return result;
    },

    EditProfile(payload: any) {
        let result = http.put('/accounts', payload);
        return result;
    }
};

export default AuthService;